export const deliveryNotes = {
  title: 'Delivery Notes',
  subtitle: 'Delivery note management and tracking',
  
  // Basic information
  list: {
    title: 'Delivery note list',
    empty: 'No delivery notes',
    loading: 'Loading delivery notes...',
    error: 'Error loading delivery notes',
    searchPlaceholder: 'Search by delivery note number, customer name, email or tracking number...',
    createNew: 'New delivery note',
    createNewSoon: 'New delivery note feature coming soon!'
  },

  // Table headers
  table: {
    number: 'Delivery note number',
    customer: 'Customer',
    date: 'Delivery date',
    status: 'Status',
    amount: 'Amount',
    tracking: 'Tracking number',
    actions: 'Actions'
  },

  // Statuses
  status: {
    draft: 'Draft',
    pending: 'Pending',
    shipped: 'Shipped',
    delivered: 'Delivered',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled'
  },

  // Actions
  actions: {
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    updateStatus: 'Update status',
    printLabel: 'Print label',
    trackPackage: 'Track package'
  },

  // Statistics
  stats: {
    total: 'Total delivery notes',
    pending: 'Pending',
    shipped: 'Shipped',
    delivered: 'Delivered'
  },

  // Status filter
  filter: {
    all: 'All',
    draft: 'Draft',
    pending: 'Pending',
    shipped: 'Shipped',
    delivered: 'Delivered',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled'
  },

  // Delivery note details
  details: {
    title: 'Delivery note details',
    basicInfo: 'Basic information',
    customerInfo: 'Customer information',
    shippingInfo: 'Shipping information',
    items: 'Delivery items',
    notes: 'Notes',
    systemInfo: 'System information',
    documentChain: 'Document chain'
  },

  // Delivery note editing
  form: {
    title: 'Edit delivery note',
    status: 'Status',
    deliveryDate: 'Delivery date',
    shippingDate: 'Shipping date',
    expectedDeliveryDate: 'Expected delivery date',
    deliveryAddress: 'Delivery address',
    deliveryInstructions: 'Delivery instructions',
    trackingNumber: 'Tracking number',
    carrierName: 'Carrier name',
    shippingMethod: 'Shipping method',
    driverName: 'Driver name',
    vehiclePlateNumber: 'Vehicle plate number',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',
    required: 'required'
  },

  // Shipping methods
  shippingMethods: {
    courier: 'Courier service',
    post: 'Postal service',
    pickup: 'Pickup',
    ownTransport: 'Own transport',
    express: 'Express delivery'
  },

  // Fields
  fields: {
    deliveryNoteNumber: 'Delivery note number',
    customerName: 'Customer name',
    customerEmail: 'Customer email',
    deliveryDate: 'Delivery date',
    shippingDate: 'Shipping date',
    expectedDeliveryDate: 'Expected delivery date',
    totalAmount: 'Total amount',
    subtotal: 'Net amount',
    currency: 'Currency',
    trackingNumber: 'Tracking number',
    carrierName: 'Carrier',
    shippingMethod: 'Shipping method',
    driverName: 'Driver name',
    vehiclePlateNumber: 'Vehicle plate number',
    deliveryAddress: 'Delivery address',
    deliveryInstructions: 'Delivery instructions',
    createdAt: 'Created',
    updatedAt: 'Updated',
    createdBy: 'Created by'
  },

  // Messages
  messages: {
    statusUpdated: 'Status updated successfully',
    deliveryNoteUpdated: 'Delivery note updated successfully',
    deliveryNoteDeleted: 'Delivery note deleted successfully',
    confirmDelete: 'Are you sure you want to delete this delivery note?',
    deleteWarning: 'This action cannot be undone!',
    trackingUpdated: 'Tracking information updated',
    delivered: 'Package delivered successfully'
  },

  // Errors
  errors: {
    loadFailed: 'Error loading delivery notes',
    updateFailed: 'Error updating delivery note',
    deleteFailed: 'Error deleting delivery note',
    notFound: 'Delivery note not found',
    invalidData: 'Invalid data',
    trackingFailed: 'Failed to retrieve tracking information'
  }
}; 